import { ActivityEntityName, EntityQueueFieldSource, EntityViewDisplay, EntityViewSortDirection } from '@jms/model';
import { dedupeLabels, resolveColumnUiFields, toQueueFieldOptions, toStageQueueFieldOptions } from '../../queue.field.options';
import { createFlagAdapter } from './flag.step.adapter';
import { QueueAdapterDeps, QueueStepAdapter } from './queue.step.adapter';

export const createFlagStageAdapter = (deps: QueueAdapterDeps): QueueStepAdapter =>
  createFlagAdapter(deps, {
    entity: ActivityEntityName.WorkOrder,
    entityLabel: 'Stage',
    resolveColumnOptions: map => {

      const flagMeta = map[ActivityEntityName.Flag];
      const jobMeta = map[ActivityEntityName.Job];
      const flagFields = flagMeta
        ? toQueueFieldOptions(resolveColumnUiFields(flagMeta), 'flag', 'Flags', true)
        : [];

      const stageFields = jobMeta
        ? toStageQueueFieldOptions(resolveColumnUiFields(jobMeta, true))
        : [];

      return dedupeLabels(flagFields, stageFields);
    },
    defaultTable: () => ({
      display: EntityViewDisplay.Table,
      fixed: [],
      other: [
        { ref: { source: EntityQueueFieldSource.Flag, path: 'flag.createdAt' }, name: 'Created', visible: true },
        { ref: { source: EntityQueueFieldSource.Flag, path: 'flag.message' }, name: 'Flag · Message', visible: true },
        { ref: { source: EntityQueueFieldSource.Entity, path: 'entity.workOrders.workOrderNumber' }, name: 'Stage · Stage Number', visible: true },
        { ref: { source: EntityQueueFieldSource.Entity, path: 'entity.customer' }, name: 'Job · Customer', visible: true },
      ],
      sortBy: { source: EntityQueueFieldSource.Flag, path: 'flag.createdAt' },
      sortOrder: EntityViewSortDirection.Desc,
    }),
  });
